import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=05d1e184&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
import style0 from "./Camera.vue?vue&type=style&index=0&id=05d1e184&prod&lang=css"
import style1 from "./Camera.vue?vue&type=style&index=1&id=05d1e184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1e184",
  null
  
)

export default component.exports